import { createNavigation } from 'next-intl/navigation';
import { defineRouting } from 'next-intl/routing';
import { i18nConfig } from '../project.config';

// @ts-ignore
export const routing = defineRouting({
  locales: i18nConfig.locales,
  defaultLocale: i18nConfig.defaultLocale,
});

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
// @ts-ignore
const { Link, redirect, usePathname, useRouter: useIntlRouter, getPathname } = createNavigation(routing);
export { Link, redirect, usePathname, getPathname, useIntlRouter };

export { useEnhancedRouter as useRouter } from 'helpers/hooks/useEnhancedRouter/useEnhancedRouter';
